import React from 'react';
import { Link } from 'react-router-dom';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { routeConstants } from 'app/routes/route-constants';
import { isDisabled } from 'app/infrastructure/data/date';
import { Tag } from 'app/components/tag';
import { DashboardAdminTranslation } from '../../constants';
import { DashboardSearchData } from '../types-store';
import { replaceTemplateString } from 'app/infrastructure/platform';
import styles from './list-item.scss';

interface ListItemProps {
  item: DashboardSearchData;
  deleting: boolean;
  deleteDashboard: (id: number, successMessage: string) => void;
  translation: DashboardAdminTranslation;
}

export const ListItem: React.FC<ListItemProps> = ({
  item, deleting, deleteDashboard, translation
}) => {

  const disabled = isDisabled(item.code.disabled);

  const handleDelete = () => {
    deleteDashboard(item.code.value, translation.dashboard_deleted);
  };

  return <div className={styles.dashboardRow}>
    {!deleting
      ? <Link className={styles.dashboardName} to={routeConstants.dashboardAdminItemFor(item.code.value)}>
        {item.code.description}
      </Link>
      : <div className={styles.dashboardName}>{item.code.description}</div>}
    {disabled
      ? <Tag className={styles.disabledTag}>
        {translation.disabled}
      </Tag>
      : null}
    <div className={styles.meatballContainer}>
      <MeatballMenu
        id={`meatball-${item.code.value}`}
        className={styles.meatball}>
        <li>
          {deleting
            ? <span className="dropdown-item disabled">{translation.edit_dashboard}</span>
            : <Link className="dropdown-item" to={routeConstants.dashboardAdminItemFor(item.code.value)}>
              {translation.edit_dashboard}
            </Link>}
        </li>
        <li>
          {deleting
            ? <span className="dropdown-item disabled">{translation.edit_dashboard_preview}</span>
            : <Link className="dropdown-item" to={routeConstants.dashboardAdminSavedReportsFor(item.code.value)}>
              {translation.edit_dashboard_preview}
            </Link>}
        </li>
        <li>
          <PromptConfirmationModal
            title={translation.delete_dashboard_title}
            description={replaceTemplateString(translation.delete_confirmation, item.code?.description)}
            continueText={translation.delete_dashboard_button}
            cancelText={translation.cancel}
            onContinue={handleDelete}>
            <button type="button"
              className="dropdown-item"
              disabled={deleting}>
              {translation.delete_dashboard_button}
            </button>
          </PromptConfirmationModal>
        </li>
        {!disabled && <li>
          {deleting
            ? <span className="dropdown-item disabled">{translation.open_dashboard}</span>
            : <Link className="dropdown-item" to={routeConstants.dashboardFor(item.code.value)}>
              {translation.open_dashboard}
            </Link>}
        </li>}
      </MeatballMenu>
    </div>
  </div>;
};
